import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Browse from './pages/Browse';
import Sports from './pages/Sports';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/browse" element={<Browse />} />
          {/* Hidden live sports page */}
          <Route path="/fat" element={<Sports />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;